import React from 'react';
import { Link } from 'react-router-dom';
import ParticleCanvas from '../components/ParticleCanvas';
import { allNews as news } from '../data/newsData';
import { allCaseStudies } from '../data/caseStudyData';

// 1. サービス画像をimportする
import serviceTrainingImg from '@/src/assets/images/service-ai-training.png';
import serviceConsultingImg from '@/src/assets/images/service-ai-consulting.png';
import serviceDevelopmentImg from '@/src/assets/images/service-ai-development.png';
import serviceLessonsImg from '@/src/assets/images/service-online-lessons.png';
import serviceAituberImg from '@/src/assets/images/service-aituber-agency.png';
import serviceCreativeImg from '@/src/assets/images/service-creative-production.png';
import serviceRecruitmentImg from '@/src/assets/images/service-Recruitment-Consultant.png'; // 修正: HR事業の画像

// --- Data ---
// 2. services 配列の順番を変更し、HR事業の詳細情報を追加
const services = [
  { title: "AI研修事業", subtitle: "AI Training", description: "<strong style='font-size:16px; font-family:YuGothic, sans-serif;'>「現場で使える」AIを、現場で育てる。</strong><br><br>実務シナリオをもとに設計された生成AI研修プログラムで、社員が“AIを使いこなす力”を習得。学ぶだけでなく、実践→改善→定着までを支援し、企業の生産性を根底から変えるリスキリング研修です。", img: serviceTrainingImg, link: "/service/ai-training" },
  { title: "AIコンサル事業", subtitle: "AI Consulting", description: "<strong style='font-size:16px; font-family:YuGothic, sans-serif;'>AI導入を“プロジェクト”で終わらせない。</strong><br><br>経営戦略から現場オペレーションまで、AIを中核に置いた事業変革を支援。AI導入のROIを明確化し、課題抽出→PoC→運用設計→定着化までをワンストップで伴走。企業ごとのKPIに直結する“AI戦略室”としての外部パートナーを担います。", img: serviceConsultingImg, link: null },
  { title: "AI開発事業", subtitle: "AI Development", description: "<strong style='font-size:16px; font-family:YuGothic, sans-serif;'>「欲しいAI」を、最短距離で形に。</strong><br><br>現場実装に特化したAIアプリケーションを開発。ユーザー体験を重視した設計と、拡張性の高いアーキテクチャで、PoC段階を超えた本番運用を実現。様々なニーズに応じたカスタムAIソリューションを提供します。", img: serviceDevelopmentImg, link: null },
  { title: "manabiya(スクール事業)", subtitle: "Online Lessons", description: "<strong style='font-size:16px; font-family:YuGothic, sans-serif;'>次の自分をつくる新時代の“学び舎”。</strong><br><br>ユーザーがマネタイズできるまで伴走する完全コミット型のオンラインスクール。<br>AIとSNSを掛け合わせ、発想・発信・成果を生み出す新しい学びのかたちを提供します。", img: serviceLessonsImg, link: null },
  { title: "クリエイティブ制作事業", subtitle: "Creative Production", description: "<strong style='font-size:16px; font-family:YuGothic, sans-serif;'>AI×人間の共創で、“伝わる”クリエイティブを。</strong><br><br>生成AIと人間の感性を融合させ、スピードと品質を両立した広告・映像・デザイン制作を実現。AIが創造を加速させるハイブリッド制作チームです。", img: serviceCreativeImg, link: null },
  { title: "HR事業", subtitle: "Recruitment Consultant", description: "<strong style='font-size:16px; font-family:YuGothic, sans-serif;'>市場に現れない「才能」を見つけ出し、AIで読み解き、対話で繋ぐ。</strong><br><br>独自のAI解析を用いて、従来の転職市場には現れないハイクラスな「潜在層」へのアプローチを実現。<br>ターゲット設計からスカウト・内定・定着までをワンストップで伴走し、企業の成長に直結する採用をサポートします。", img: serviceRecruitmentImg, link: null },
  { title: "AITuber事業", subtitle: "AIuTber Agency", description: "<strong style='font-size:16px; font-family:YuGothic, sans-serif;'>「人がつくるAI」から、「AIがつくる人」へ。</strong><br><br>コンテンツ生成の新境地。AIキャラクターが自ら台本を作り、感情を学び、リアルタイムに配信する。教育・マーケティング・ブランディングを融合した“AIトークメディア”です。", img: serviceAituberImg, link: null }
];


// --- HomePage Components ---

const HeroSection: React.FC = () => (
  <section className="relative w-full h-screen overflow-hidden bg-white">
    <ParticleCanvas />
    <div className="relative z-30 w-full h-full flex items-center justify-center text-center text-gray-800 px-4">
      <div className="animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
        <h1 
          className="text-4xl sm:text-6xl md:text-8xl lg:text-9xl font-light tracking-wider bg-clip-text text-transparent bg-gradient-to-br from-gray-900 via-gray-800 to-gray-600"
          style={{ 
            fontFamily: "'Noto Serif JP', serif",
            textShadow: '0 1px 3px rgba(0, 0, 0, 0.2), 0 4px 12px rgba(0, 0, 0, 0.15)',
            lineHeight: 1.3,
          }}
        >
          革新を<span style={{ marginLeft: '-0.05em', marginRight: '-0.30em' }}>、</span>日常に。
        </h1>
        <p 
          className="text-gray-500 font-light mt-4 text-xs sm:text-base md:text-lg tracking-[0.2em] sm:tracking-[0.25em] md:tracking-[0.3em] lg:tracking-[0.38em] uppercase"
          style={{ 
            fontFamily: "'Noto Serif JP', serif"
          }}
        >
            Making Innovation the new Ordinary
        </p>
      </div>
    </div>
  </section>
);

const MissionSection: React.FC = () => (
    <section id="mission" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
            <div className="text-center md:text-left mb-10">
                <h2 className="text-3xl md:text-4xl font-bold">Mission</h2>
                <p className="text-lg text-gray-600 mt-2">企業理念</p>
            </div>
            <div className="grid md:grid-cols-2 gap-x-12 gap-y-8">
                <div className="text-center md:text-left">
                    <p className="text-2xl md:text-3xl font-bold text-[#3aabd2]">AIで日本をアップデートする</p>
                </div>
                <div>
                    <p className="text-gray-600" dangerouslySetInnerHTML={{ __html: '私たちは、AIの力で新たな時代を切り拓いてまいります。<br>いま、この国が直面する変化の波を恐れず、テクノロジーを誰もが活かせる社会へ。<br>日本が再び世界をリードする、その原動力を創り出してまいります。' }}></p>
                </div>
            </div>
        </div>
    </section>
);


const ServiceCard: React.FC<{ service: typeof services[0] }> = ({ service }) => {
  const cardContent = (
    <div className="relative overflow-hidden rounded-lg shadow-lg group h-full flex flex-col border border-gray-200">
      <div className="relative">
        <img src={service.img} alt={service.title} className="w-full h-56 object-cover transition-transform duration-500 group-hover:scale-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
      </div>
      <div className="p-6 bg-white flex-grow flex flex-col">
        <h4 className="text-sm font-semibold text-[#3aabd2] uppercase tracking-wider">{service.subtitle}</h4>
        <h3 className="text-xl font-bold text-gray-900 mt-1">{service.title}</h3>
        <p className="text-gray-600 mt-2 text-sm flex-grow" dangerouslySetInnerHTML={{ __html: service.description }}></p>
        {service.link && <span className="text-[#3aabd2] font-semibold mt-4 block">Read More →</span>}
      </div>
    </div>
  );

  return service.link ? (
    <Link to={service.link} className="block transition-transform duration-300 hover:-translate-y-2 h-full">
      {cardContent}
    </Link>
  ) : (
    <div className="block cursor-not-allowed h-full opacity-80">
      {cardContent}
    </div>
  );
};

const ServicesSection: React.FC = () => (
  <section id="service" className="py-20 bg-white">
    <div className="container mx-auto px-6">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold">Our Services</h2>
        <p className="text-lg text-gray-600 mt-2">事業内容</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* slice(0, 6)を追加し、上位6件(AITuber事業以外)のみ表示 */}
        {services.slice(0, 6).map((service, index) => <ServiceCard key={index} service={service} />)}
      </div>
      <div className="text-center mt-12">
        <Link to="/service" className="inline-flex items-center justify-center py-3 px-8 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-[#3aabd2] hover:bg-[#2f8faf] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3aabd2] transition-all duration-300">
            サービス一覧を見る
        </Link>
      </div>
    </div>
  </section>
);

const CaseStudyCard: React.FC<{ caseStudy: typeof allCaseStudies[0] }> = ({ caseStudy }) => (
  <Link to={caseStudy.link} className="block group transition-all duration-300 hover:-translate-y-2 h-full">
    <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200 h-full flex flex-col">
      <div className="aspect-video bg-white flex items-center justify-center p-0 overflow-hidden">
        <img src={caseStudy.logo} alt={caseStudy.companyName} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
      </div>
      <div className="border-t border-[#454545]/16"></div>
      <div className="p-6 flex-grow flex flex-col">
        <div className="mb-3">
          <span className="inline-block px-3 py-1 border border-[#3aabd2] text-[#3aabd2] text-xs font-medium rounded">
            {caseStudy.category}
          </span>
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">{caseStudy.companyName}</h3>
        <p className="text-gray-600 text-sm line-clamp-3 leading-relaxed" dangerouslySetInnerHTML={{ __html: caseStudy.summary }}></p>
      </div>
    </div>
  </Link>
);

const CaseStudySection: React.FC = () => (
  <section id="case-study" className="py-20 bg-white">
    <div className="container mx-auto px-6">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Inter', sans-serif" }}>Case Study</h2>
        <p className="text-lg text-[#4b5563]" style={{ fontFamily: "'Inter', sans-serif" }}>事例紹介</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {[...allCaseStudies].sort((a, b) => b.id - a.id).slice(0, 3).map((item) => (
          <CaseStudyCard key={item.id} caseStudy={item} />
        ))}
      </div>
      <div className="text-center mt-12">
        <Link to="/case-study" className="inline-flex items-center justify-center py-3 px-8 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-[#3aabd2] hover:bg-[#2f8faf] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3aabd2] transition-all duration-300">
          事例紹介一覧を見る
        </Link>
      </div>
    </div>
  </section>
);

const NewsSection: React.FC = () => (
    <section id="news" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
            <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold">News</h2>
                <p className="text-lg text-gray-600 mt-2">お知らせ</p>
            </div>
            <div className="max-w-3xl mx-auto">
                <ul className="space-y-4">
                    {news.slice(0, 5).map(item => (
                        <li key={item.id} className="border-b border-gray-200 pb-4 last:border-b-0">
                            <Link to={item.link} className="flex flex-col sm:flex-row items-baseline group">
                                <span className="text-gray-500 font-medium w-full sm:w-32 mb-1 sm:mb-0 flex-shrink-0">{item.date}</span>
                                <span className="text-gray-800 group-hover:text-[#3aabd2] transition-colors duration-300">{item.title}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="text-center mt-12">
                <Link to="/news" className="inline-flex items-center justify-center py-3 px-8 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-[#3aabd2] hover:bg-[#2f8faf] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3aabd2] transition-all duration-300">
                    ニュース一覧を見る
                </Link>
            </div>
        </div>
    </section>
);


const HomeContactSection: React.FC = () => (
    <section id="contact" className="py-20 bg-white">
        <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold">Contact</h2>
            <p className="text-lg text-gray-600 mt-2 max-w-2xl mx-auto">ご相談、サービスに関するご質問など、お気軽にお問い合わせください。</p>
            <div className="mt-8">
                <Link to="/contact" className="inline-flex items-center justify-center py-3 px-8 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-[#3aabd2] hover:bg-[#2f8faf] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3aabd2] transition-all duration-300">
                    メールで問い合わせる
                </Link>
            </div>
        </div>
    </section>
);


const HomePage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <MissionSection />
      <ServicesSection />
      <CaseStudySection />
      <NewsSection />
      <HomeContactSection />
    </>
  );
};

export default HomePage;